import React from 'react';
import { Spinner } from 'app/components/primitives';

interface LoadingPillProps {
  message: string;
  details?: string[];
}

// Carries no position of its own: the caller pins it to the viewport for
// app-wide waits, or centres it in a container for modal-scoped ones.
export const LoadingPill: React.FC<LoadingPillProps> = ({
  message,
  details = [],
}) => (
  <div
    role="status"
    aria-live="polite"
    aria-busy="true"
    className="flex items-center justify-center gap-3 px-6 py-4 shadow-lg bg-blue-600 rounded-3xl text-white text-sm font-bold min-w-[200px]"
  >
    <div className="flex flex-col gap-1">
      <span>{message}</span>
      {details.map((detail) => (
        <span key={detail} className="text-xs font-normal text-blue-50">
          {detail}
        </span>
      ))}
    </div>
    {/* Spinner takes no colour prop, and antd paints the dots from
        colorPrimary — invisible on the blue pill without this. */}
    <Spinner size="md" className="[&_.ant-spin-dot-item]:!bg-white" />
  </div>
);

export default LoadingPill;
